if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.tryGetForm();
    }
    tryGetForm() {
      const form = this.querySelector('form');
      if (!form) {
        console.log('Form not found. Retrying in 10ms.');
        setTimeout(() => this.tryGetForm(), 10);
      } else {
        console.log('Form found!');
        this.form = form;
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }
/*  
      this.form = this.querySelector('form');
console.log('error point');      
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }
*/
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**********************************************************************
  Change SKU and Disable add button if selected options have no SKU
**********************************************************************/
let lastVariant = null;
let intervalId = null;

function attachClickListener() {
  const bcpoElement = document.querySelector('#bcpo');
  if (!bcpoElement) {
    setTimeout(attachClickListener, 100);
    return;
  }

  bcpoElement.addEventListener('click', function(event) {
    const target = event.target;
    if (!target.classList.contains('bcpo-front-button-label')) {
      return;
    }
    
    clearInterval(intervalId);
    intervalId = setInterval(checkVariant, 250);
    setTimeout(function() {
      clearInterval(intervalId);
    }, 1000);
  });
}

function checkVariant() {
  const urlParams = new URLSearchParams(window.location.search);
  const variant = urlParams.get('variant');
  if (variant === lastVariant) {
    return;
  }
  
  lastVariant = variant;
  const sku = variantSku[variant] || '';
  document.querySelector('span.sku').innerText = sku;
  const button = document.querySelector('button.product-form__submit');
  button.disabled = !sku;
  console.log(sku ? 'Enabled Button' : 'Disabled Button');
}

attachClickListener();


/*
function attachClickListener() {
  const bcpoElement = document.querySelector('#bcpo');
  if (bcpoElement) {
    bcpoElement.addEventListener('click', function(event) {
      const target = event.target;
      if (target.classList.contains('bcpo-front-button-label')) {
        const urlParams = new URLSearchParams(window.location.search);
        const variant = urlParams.get('variant');
        if(variant === lastVariant) {
          return;
        }
        lastVariant = variant;
        const sku = variantSku[variant] || '';
        const skuSpan = document.querySelector('span.sku');
        skuSpan.innerText = sku;
        console.log(sku);
        const button = document.querySelector('button.product-form__submit');
        button.disabled = !sku;
        console.log(sku ? 'Enabled Button' : 'Disabled Button');
      }
    }, false);
  } else {
    setTimeout(attachClickListener, 100);
  }
}

let lastVariant = null;
attachClickListener();

let intervalId = window.setInterval(function() {
  const urlParams = new URLSearchParams(window.location.search);
  const variant = urlParams.get('variant');
  if (variant !== lastVariant) {
    lastVariant = variant;
    const sku = variantSku[variant] || '';
    const skuSpan = document.querySelector('span.sku');
    skuSpan.innerText = sku;
    console.log(sku);
    const button = document.querySelector('button.product-form__submit');
    button.disabled = !sku;
    console.log(sku ? 'Enabled Button' : 'Disabled Button');
  }
}, 250);
*/